import React from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { IDLE_TIMEOUT } from '../utils/constants';

const useIdleTimeout = () => {
  const [show, setShow] = React.useState(false);

  const { reset } = useIdleTimer({
    onIdle: () => {
      setShow(true);
    },
    timeout: IDLE_TIMEOUT,
  });

  const handleResetIdleTimer = () => {
    setShow(false);
    reset();
  };

  return { show, handleResetIdleTimer };
};

export default useIdleTimeout;
